import axios from 'axios';
export const maxQueryFailures = 3;
/**
 * error is retryable when
 * - it is an axios error
 * - response status is 5xx
 *
 * @param maybeAxiosError
 * @returns
 */
export const isRetriableError = (maybeAxiosError) => axios.isAxiosError(maybeAxiosError) &&
    maybeAxiosError.response?.status?.toString().length === 3 &&
    maybeAxiosError.response?.status?.toString().startsWith('5');
const randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min));
/**
 * @param tries Number of the current attempt from `1` to Infinity
 * @returns Delay in milliseconds
 * - 200ms and 500ms for the first attempt
 * - 1s and 3s for the second attempt
 * - 5s and 10s for the third attempt
 * - 55s and 60s for all other attempts
 */
export const retryDelayWithJitter = (tries) => [randomBetween(200, 500), randomBetween(1000, 3000), randomBetween(5000, 10_000)][tries - 1] ||
    randomBetween(55_000, 60_000);
//# sourceMappingURL=network.js.map